export const ROUTES_PREFIXES = {
  NG: '/ng',
  PRODUCT: '/products',
};

export const ROUTES_PATHS = {
  MAIN: '/',
  USEFUL: '/useful',
  CERTIFICATES: '/certificates',
  DELIVERY: '/delivery',
  CONTACTS: '/contacts',
  PERSONAL: '/lk',
  REGISTRATION: '/lk-reg',
  FAST_REGISTRATION: '/fast-registration',
  CART: '/cart',
  CART_REG: '/cart-reg',
  NG_SUBGROUP_DETAIL: `${ROUTES_PREFIXES.NG}/:slug/:subgroupSlug`,
  NG_DETAIL: `${ROUTES_PREFIXES.NG}/:slug`,
  PRODUCT_DETAIL: `${ROUTES_PREFIXES.PRODUCT}/:slug`,
  ARTICLES: '/articles',
  ARTICLE_DETAIL: '/articles/:slug',
};
